var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-charts',{staticStyle:{"height":"10rem","width":"100%"},attrs:{"option":_vm.option,"theme":"theme-color","auto-resize":""}})}
var staticRenderFns = []

export { render, staticRenderFns }